/** Platform admins (users.id). Finance dashboards — only FULL_FINANCE. */
export const ADMIN_USER_IDS = [1, 2];
export const ADMIN_FINANCE_USER_IDS = [1];

export function isAdminUser(userId) {
  const id = Number(userId);
  return ADMIN_USER_IDS.includes(id);
}

export function canViewAdminFinance(userId) {
  const id = Number(userId);
  return ADMIN_FINANCE_USER_IDS.includes(id);
}
